export const CURRENT_PORTAL_DOM_BLOB_LOADED = 'CURRENT_PORTAL_DOM_BLOB_LOADED';
